module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('title-user', [_vm._v("\n        Planos\n        "), _c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v(" Contrato " + _vm._s(_vm.contractId) + "\n        "), _c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v(" Passagens Pendentes\n      ")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-yellow"
  }), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  })], 1)]), _vm._v(" "), (_vm.contract.status.contractStatusId == 5) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('h3', {
    staticClass: "alert-title"
  }, [_vm._v("Contrato bloqueado!")]), _vm._v("\n    Seu contrato foi bloqueado, pois você possuí pagamentos pendentes, após 15 dias da data do bloqueio seu contrato será cancelado. Para que não ocorra o cancelamento do contrato, efetue o reprocessamento dos pagamentos pendentes.\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "margin-t20 table-white-header",
    staticStyle: {
      "min-height": "100px"
    }
  }, [(_vm.messageError) ? _c('div', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm.messageError))]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "table stripped-odd no-footer",
    attrs: {
      "role": "grid"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.orders), function(order, index) {
    return _c('detail-order', {
      key: order.orderId,
      attrs: {
        "order": order
      }
    })
  }), 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('button', {
    staticClass: "btn btn-success margin-t20 pull-right",
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }, [_vm._v("\n              Reprocessar\n              "), _c('i', {
    staticClass: "icon-coin align-icon-right"
  })])])])])]), _vm._v(" "), (_vm.showModal) ? _c('reprocess', {
    attrs: {
      "contractId": _vm.contractId,
      "orderId": _vm.allOrderIds
    },
    on: {
      "close": function($event) {
        _vm.showModal = false
      },
      "reprocessConfirmed": _vm.loadData
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "vertical-center",
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("N° Pedido")]), _vm._v(" "), _c('th', {
    staticClass: "vertical-center",
    attrs: {
      "width": "18%"
    }
  }, [_vm._v("Solicitação do Pedido")]), _vm._v(" "), _c('th', {
    staticClass: "vertical-center",
    attrs: {
      "width": "22%"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "vertical-center",
    attrs: {
      "width": "35%"
    }
  }, [_vm._v("Tipo de Compra")]), _vm._v(" "), _c('th', {
    staticClass: "vertical-center text-right",
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("Valor em R$")]), _vm._v(" "), _c('th')])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-0412b9c1!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/request/reprocess-orders.vue
// module id = 2038
// module chunks = 1